import axios from "axios";
import { CUR8_SERVER } from "gatsby-env-variables";
import { InitializeApi } from "@ifgengineering/client-auth-sdk";

export const authSdk = InitializeApi({
  serverURL: CUR8_SERVER,
  appAxios: axios,
});
